import { cn } from '@tripleten/cn';

export const cnInputWrapper = cn('input-wrapper');
